import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ResultadoProcesoResumenMasivoInquilinosDto } from '@models/resultadoResumenInquilinoEnvioCorreo/resultadoProcesoResumenMasivoInquilinosDto.model';
import { ResultadoResumenInquilinoEnvioCorreoDto } from '@models/resultadoResumenInquilinoEnvioCorreo/resultadoResumenInquilinoEnvioCorreoDto.model';
import { HotToastService } from '@ngneat/hot-toast';
import { ResultadoResumenInquilinoEnvioCorreoService } from '@services/resultado-proceso-resumen-masivo-inquilinos/resultado-proceso-resumen-masivo-inquilinos.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { GenericDialogComponent } from '@views/genericos/generic-dialog/generic-dialog.component';
import { data } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-generar-resumen-mensual',
  templateUrl: './generar-resumen-mensual.component.html',
  styleUrls: ['./generar-resumen-mensual.component.css']
})
export class GenerarResumenMensualComponent implements OnInit {
  procesado: boolean = false;
  detalleResumen!: ResultadoProcesoResumenMasivoInquilinosDto;
  displayedColumns: string[] = []
  verTabla: boolean = false
  formBuilder = new FormBuilder
  dataSource = new MatTableDataSource<ResultadoResumenInquilinoEnvioCorreoDto>();
  lstResumenFilter!: string[];
  formularioProceso!: FormGroup;
  lstProcesosMasivos: string[] = [];
  selectedTabIndex: number = 0;

  constructor(public dialogMensajeDetalle: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private toastService: HotToastService,
    private breakpointObserver: BreakpointObserver,
    private resultadoResumenInquilinoEnvioCorreoService: ResultadoResumenInquilinoEnvioCorreoService) { }

  ngOnInit(): void {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = ['numeroContrato', 'generacionResumenExitosa', 'generacionArchivoExitosa', 'envioExitoso', 'emailValido', 'emailDestino', 'tiempoDuracionEnvio', 'metodoEnvio', 'fechaEnvio', 'mensaje']
    });

    this.formularioProceso = this.formBuilder.group({
      idProcesoMasivo: [null, Validators.compose([Validators.required])]
    });

    const resultadoResumenInquilinoEnvioCorreoService = this.resultadoResumenInquilinoEnvioCorreoService.getResultadoProcesoResumenMasivoInquilinosDto();

    if(resultadoResumenInquilinoEnvioCorreoService)
      this.detalleResumen = resultadoResumenInquilinoEnvioCorreoService

    if (this.detalleResumen) {
      this.dataSource.data = this.detalleResumen.resultados;
      this.verTabla = this.dataSource.data.length >= 1 ? true : false

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.selectedTabIndex = 1;
    }

    this.getResumenAgrupadoPorProceso()
  }

  ngOnChanges(changes: SimpleChanges): void {

    const resultadoResumenInquilinoEnvioCorreoService = this.resultadoResumenInquilinoEnvioCorreoService.getResultadoProcesoResumenMasivoInquilinosDto();

    if(resultadoResumenInquilinoEnvioCorreoService)
      this.detalleResumen = resultadoResumenInquilinoEnvioCorreoService

    if (this.detalleResumen) {
      this.dataSource.data = this.detalleResumen.resultados;
      this.verTabla = this.dataSource.data.length >= 1 ? true : false

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.selectedTabIndex = 1;
    }
  }

  procesoFinalizado($event: any) {
    this.detalleResumen = $event
    if (this.detalleResumen) {
      this.dataSource.data = this.detalleResumen.resultados;
      this.verTabla = this.dataSource.data.length >= 1 ? true : false

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.selectedTabIndex = 1;
    }
  }

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openMessageDialog(element: any): void {
    this.dialogMensajeDetalle.open(GenericDialogComponent, {
      data: { head: 'Ver detalle', body: element }
    });
  }

  getResumenAgrupadoPorProceso() {
    this.spinner.show("spBusquedaProcesoMasivo")
    this.resultadoResumenInquilinoEnvioCorreoService.getResumenAgrupadoPorProceso()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaProcesoMasivo")
          this.lstResumenFilter = data
        },
        error => {
          this.spinner.hide("spBusquedaProcesoMasivo")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getAllResumenByIdProcesoMasivo(idProcesoMasivo: string) {
    this.spinner.show("spResultadoEnvioMasivo")
    this.resultadoResumenInquilinoEnvioCorreoService.getAllResumenByIdProcesoMasivo(idProcesoMasivo)
      .subscribe(
        data => {
          this.spinner.hide("spResultadoEnvioMasivo")
          this.detalleResumen = data

          if (this.detalleResumen) {
            this.dataSource.data = this.detalleResumen.resultados;
            this.verTabla = this.dataSource.data.length >= 1 ? true : false

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.selectedTabIndex = 1;
          }
        },
        error => {
          this.spinner.hide("spResultadoEnvioMasivo")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  onProcesoMasivoChange(id: string) {
    this.getAllResumenByIdProcesoMasivo(id);
    this.selectedTabIndex = 1;
  }

  trackByItems(index: number, item: any): any {
    return item;
  }

}
